<ion-header class="ion-no-border">
	<ion-toolbar>
		<ion-buttons slot="start">
			<ion-button (click)="close()">
				<fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
			</ion-button>
		</ion-buttons>
		<ion-title>Change discount</ion-title>
		<ion-buttons slot="end">
			<ion-button (click)="update()">
				<fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>

</ion-header>

<ion-content>

    <ion-grid class="form">
        <ion-row>
            <ion-col>
                <ion-grid class="fieldset">
                    <ion-row>
                        <ion-col>
                            <ion-input debounce="200" max="100" min="0" type="tel" inputmode="decimal" maxlength="10" label="Discount (%)" labelPlacement="stacked" fill="outline" [(ngModel)]="discount_rate" (keydown.enter)="enterPressed($event)"></ion-input>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>
    </ion-grid>

</ion-content>
